module.exports = __webpack_public_path__ + "static/img/ptGame1.64a4427.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/ptGame1.webp
// module id = /AqT
// module chunks = 3